import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles.css";
import Navbar from "./NavBar.js";
import Home from "./Home.js";
import About from "./About.js";
import Gallery from "./Gallery.js";
import Footer from "./Footer.js";

const App = () => {
  return (
    <BrowserRouter>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="*" element={<NoMatchPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

const NoMatchPage = () => {
  return <h3 className="homeTitle">404 - Not found</h3>;
};

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
